/**
 * binaida 실제 데이터베이스 Order / OrderImage 사찰별 촛불 및 관리자 인증 사진 데이터
 */

export const REAL_TEMPLE_CANDLES_DB = {
  // 1. 봉은사
  "baee5735-98a8-49cb-a541-1b6243372902": [
    {
      id: "real-bongeun-1",
      donorName: "하만수",
      birthDate: "1986년생",
      category: "삼재소멸",
      wish: "삼재를 소멸하고 온 가족에게 부처님의 자비광명이 가득하길 발원합니다.",
      candleColor: "gold",
      itemName: "돈타래반야심경 초",
      durationDays: 7,
      prayCount: 28,
      orderDate: "2024-04-24",
      templeName: "봉은사",
      isExpired: true,
      adminImages: [
        "https://binaida-asset.s3.ap-northeast-2.amazonaws.com/order-8248aa78-0bca-4219-b7c1-638ac7a7715e/1783749173028.jpg",
        "https://binaida-asset.s3.ap-northeast-2.amazonaws.com/order-8248aa78-0bca-4219-b7c1-638ac7a7715e/1000028132.jpg",
      ],
      adminMessage: "봉은사 대웅전 부처님 전에 하만수 님의 소원초를 정성껏 봉안하고 삼재소멸 축원을 올렸습니다. 성불하십시오.",
    },
    {
      id: "real-bongeun-2",
      donorName: "하만수",
      birthDate: "1986년생",
      category: "소원성취",
      wish: "온 가족 올 한 해 병고 없이 건강하고 원만히 소원성취하기를 간절히 발원합니다.",
      candleColor: "white",
      itemName: "원백 반야심경 초",
      durationDays: 30,
      prayCount: 42,
      orderDate: "2024-04-23",
      templeName: "봉은사",
      isExpired: true,
      adminImages: [
        "https://binaida-asset.s3.ap-northeast-2.amazonaws.com/order-b3d6846f-0a69-4268-be74-46996d332d49/Gemini_Generated_Image_dooq0jdooq0jdooq.jpg",
      ],
      adminMessage: "원백 반야심경 초에 불을 밝혀 온 가족의 평안과 만사형통을 지극한 마음으로 발원해 드렸습니다.",
    },
    {
      id: "real-bongeun-3",
      donorName: "하만수",
      birthDate: "",
      category: "사업/재물",
      wish: "새로 시작하는 일터에 만복이 깃들고 재물과 복덕이 번창하기를 발원합니다.",
      candleColor: "jade",
      itemName: "원백밀랍 굵은초",
      durationDays: 49,
      prayCount: 19,
      orderDate: "2024-04-23",
      templeName: "봉은사",
      isExpired: true,
      adminImages: [
        "https://binaida-asset.s3.ap-northeast-2.amazonaws.com/order-b53d804f-3fb7-4a26-b56e-d74b9a246a04/220288a6-fac8-49bf-9ba7-f151075f2bd6.jpg",
      ],
      adminMessage: "일터의 번영과 재물 성취를 위해 대웅전 불단 중앙에 굵은 밀랍초를 점등하였습니다.",
    },
    {
      id: "real-bongeun-4",
      donorName: "하만수 가족",
      birthDate: "",
      category: "가정화목",
      wish: "가정 내 모든 액운이 소멸되고 가족 모두 평안하고 화목하기를 발원합니다.",
      candleColor: "pink",
      itemName: "돈타래반야심경 초",
      durationDays: 100,
      prayCount: 65,
      orderDate: "2024-04-23",
      templeName: "봉은사",
      isExpired: true,
      adminImages: [
        "https://binaida-asset.s3.ap-northeast-2.amazonaws.com/order-b3d6846f-0a69-4268-be74-46996d332d49/20260710_192917.jpg",
      ],
      adminMessage: "가족 모두의 건강과 화목을 위해 백일간 정성으로 향과 촛불을 공양합니다.",
    },
  ],

  // 2. 청계사
  "5f5f4e8f-be98-4162-8dc4-43b849e48fdd": [
    {
      id: "real-cheonggye-1",
      donorName: "원성준",
      birthDate: "1978.10.09",
      category: "건강발원",
      wish: "원성준(19781009) - 온 가족 심신이 건강하고 일체 액난이 소멸되며 만복이 깃들기를 간절히 발원합니다.",
      candleColor: "gold",
      itemName: "소원 초",
      durationDays: 30,
      prayCount: 54,
      orderDate: "2026-07-20",
      templeName: "청계사",
      isExpired: true,
      adminImages: [
        "https://binaida-asset.s3.ap-northeast-2.amazonaws.com/order-8248aa78-0bca-4219-b7c1-638ac7a7715e/1783749173028.jpg",
        "https://binaida-asset.s3.ap-northeast-2.amazonaws.com/order-8248aa78-0bca-4219-b7c1-638ac7a7715e/1000028132.jpg",
      ],
      adminMessage: "청계사 대웅전 불단에 원성준 불자님의 건강발원 소원초를 정갈하게 봉안하고 축원을 마쳤습니다.",
    },
    {
      id: "real-cheonggye-2",
      donorName: "하만수",
      birthDate: "",
      category: "가족화목",
      wish: "부처님 전에 정성을 다하여 온 가족 화목과 소원성취를 발원합니다.",
      candleColor: "jade",
      itemName: "소원 초",
      durationDays: 30,
      prayCount: 31,
      orderDate: "2026-07-16",
      templeName: "청계사",
      isExpired: true,
      adminImages: [
        "https://binaida-asset.s3.ap-northeast-2.amazonaws.com/order-b3d6846f-0a69-4268-be74-46996d332d49/20260710_192917.jpg",
      ],
      adminMessage: "청계사 도량의 청정한 기운으로 온 가족의 안온과 화목을 발원하였습니다.",
    },
    {
      id: "real-cheonggye-3",
      donorName: "하만수",
      birthDate: "1986년생",
      category: "가족화목",
      wish: "일체 번뇌를 내려놓고 가정의 평화와 성불을 발원합니다.",
      candleColor: "white",
      itemName: "소원 초",
      durationDays: 49,
      prayCount: 22,
      orderDate: "2026-05-19",
      templeName: "청계사",
      isExpired: true,
      adminImages: [
        "https://binaida-asset.s3.ap-northeast-2.amazonaws.com/order-b3d6846f-0a69-4268-be74-46996d332d49/Gemini_Generated_Image_dooq0jdooq0jdooq.jpg",
      ],
      adminMessage: "사찰 불단에 백색 소원초를 켜고 마음의 평안과 번뇌 소멸을 축원했습니다.",
    },
    {
      id: "real-cheonggye-4",
      donorName: "하만수 가족",
      birthDate: "",
      category: "소원성취",
      wish: "청계사 청정 도량에서 간절한 서원이 원만 성취되기를 발원합니다.",
      candleColor: "pink",
      itemName: "소원 초 (백일기도)",
      durationDays: 100, // 100일 불공
      prayCount: 47,
      orderDate: "2026-05-19",
      templeName: "청계사",
      isExpired: true,
      adminImages: [
        "https://binaida-asset.s3.ap-northeast-2.amazonaws.com/order-8248aa78-0bca-4219-b7c1-638ac7a7715e/1000028132.jpg",
      ],
      adminMessage: "불단에 밝힌 촛불이 꺼지지 않고 소원 성취의 등불이 되길 기원합니다.",
    },
  ],

  // 3. 선운정사
  "6d23b2f3-419f-48af-ac2e-3854380bbf8a": [
    {
      id: "real-seonun-1",
      donorName: "한광석",
      birthDate: "1980.02.05",
      category: "학업/합격",
      wish: "한광석(1980.02.05) - 간절히 준비한 시험에 원만히 합격하여 뜻을 펼치게 하소서.",
      candleColor: "gold",
      itemName: "소원초 (30일 불공)",
      durationDays: 30,
      prayCount: 38,
      orderDate: "2024-06-22",
      templeName: "선운정사",
      isExpired: true,
      adminImages: [
        "https://binaida-asset.s3.ap-northeast-2.amazonaws.com/order-a6cee10e-27e5-4a2a-80d7-af34a47ec70c/f9909c07-effe-4e38-b647-cd7f656a6c1664628984652636010.jpg",
      ],
      adminMessage: "선운정사 부처님 전에 한광석 님의 시험합격 발원초를 점등하여 지혜의 등불을 밝혔습니다.",
    },
    {
      id: "real-seonun-2",
      donorName: "원성준",
      birthDate: "",
      category: "사업/재물",
      wish: "북경에서 추진하는 사업이 순풍에 돛 단 듯 번창하고 결실을 맺게 하소서.",
      candleColor: "jade",
      itemName: "소원초",
      durationDays: 30,
      prayCount: 67,
      orderDate: "2024-04-04",
      templeName: "선운정사",
      isExpired: true,
      adminImages: [
        "https://binaida-asset.s3.ap-northeast-2.amazonaws.com/order-381b259d-d44b-494a-879f-3ff43caadf37/1e1a33fa-8527-4adc-8345-7385f67f259414522960535355451.jpg",
      ],
      adminMessage: "원성준 불자님의 해외 사업 순항과 사업 번창을 기원하며 정성껏 기도를 올렸습니다.",
    },
    {
      id: "real-seonun-3",
      donorName: "원성준",
      birthDate: "",
      category: "건강/쾌차",
      wish: "속득쾌차 - 앓고 있는 모든 질병이 조속히 쾌유되고 건강을 되찾길 발원합니다.",
      candleColor: "white",
      itemName: "소원등",
      durationDays: 30,
      prayCount: 45,
      orderDate: "2024-03-27",
      templeName: "선운정사",
      isExpired: true,
      adminImages: [
        "https://binaida-asset.s3.ap-northeast-2.amazonaws.com/order-6486aad9-1767-466f-8e20-9544ed2664c2/6f1ef515-533b-4f0e-82a0-a43cb07ef44556997971546813606.jpg",
      ],
      adminMessage: "약사여래 부처님의 가피로 환우의 병고가 조속히 쾌차되기를 지극정성으로 기도드렸습니다.",
    },
    {
      id: "real-seonun-4",
      donorName: "강호길",
      birthDate: "1970.09.22",
      category: "소원성취",
      wish: "강호길(1970.09.22) - 소원성취와 올 한 해 즐겁고 평안한 일상이 이어지길 기원합니다.",
      candleColor: "pink",
      itemName: "소원등 (백일기도)",
      durationDays: 100,
      prayCount: 29,
      orderDate: "2023-10-13",
      templeName: "선운정사",
      isExpired: true,
      adminImages: [
        "https://binaida-asset.s3.ap-northeast-2.amazonaws.com/order-e2b47efd-0136-4b8a-a45a-39256f18ced8/ff4a26dd-a082-467d-ae26-7b3f339d463c98707804650075239.jpg",
      ],
      adminMessage: "강호길 불자님의 정성이 담긴 연등을 명당자리에 공양하였습니다.",
    },
    {
      id: "real-seonun-5",
      donorName: "최인영",
      birthDate: "1967년생",
      category: "가족건강",
      wish: "최인영(67년생) - 무병장수하고 신심이 늘 평안하며 행복하기를 발원합니다.",
      candleColor: "gold",
      itemName: "소원초 (100일 불공)",
      durationDays: 100,
      prayCount: 52,
      orderDate: "2023-09-09",
      templeName: "선운정사",
      isExpired: true,
      adminImages: [
        "https://binaida-asset.s3.ap-northeast-2.amazonaws.com/order-6486aad9-1767-466f-8e20-9544ed2664c2/6f1ef515-533b-4f0e-82a0-a43cb07ef44556997971546813606.jpg",
      ],
      adminMessage: "무병장수와 가내 평안을 위해 정성껏 초를 밝히고 축원장을 올렸습니다.",
    },
    {
      id: "real-seonun-6",
      donorName: "하만수",
      birthDate: "",
      category: "인연/혼사",
      wish: "어질고 좋은 인연을 만나 아름다운 가정을 꾸릴 수 있기를 정성으로 발원합니다.",
      candleColor: "jade",
      itemName: "소원초 공양",
      durationDays: 49,
      prayCount: 33,
      orderDate: "2024-04-09",
      templeName: "선운정사",
      isExpired: true,
      adminImages: [
        "https://binaida-asset.s3.ap-northeast-2.amazonaws.com/order-381b259d-d44b-494a-879f-3ff43caadf37/1e1a33fa-8527-4adc-8345-7385f67f259414522960535355451.jpg",
      ],
      adminMessage: "선남자 선여인의 길한 인연이 맺어지기를 기원하며 공양미와 초를 올렸습니다.",
    },
  ],

  // 4. 보덕사
  "b9b4c4c1-f0fb-4aa1-8b19-6688e72d0fd5": [
    {
      id: "real-bodeok-1",
      donorName: "하만수",
      birthDate: "1986년생",
      category: "운수대통",
      wish: "하만수(1986년생) - 묵은 액운이 물러가고 사방에서 귀인과 복덕이 찾아오길 발원합니다.",
      candleColor: "gold",
      itemName: "불공 기도",
      durationDays: 30,
      prayCount: 44,
      orderDate: "2025-12-11",
      templeName: "보덕사",
      isExpired: true,
      adminImages: [
        "https://binaida-asset.s3.ap-northeast-2.amazonaws.com/order-b53d804f-3fb7-4a26-b56e-d74b9a246a04/220288a6-fac8-49bf-9ba7-f151075f2bd6.jpg",
      ],
      adminMessage: "보덕사 법당에서 하만수 님의 운수대통과 소원성취를 위해 특별 축원 기도를 봉행하였습니다.",
    },
    {
      id: "real-bodeok-2",
      donorName: "하하",
      birthDate: "",
      category: "사업/승진",
      wish: "속득진급 - 직장에서 신임을 얻고 순조롭게 진급과 성취를 이루기를 기원합니다.",
      candleColor: "jade",
      itemName: "불공 기도",
      durationDays: 60,
      prayCount: 27,
      orderDate: "2025-12-11",
      templeName: "보덕사",
      isExpired: true,
      adminImages: [
        "https://binaida-asset.s3.ap-northeast-2.amazonaws.com/order-1524ad36-aeed-422d-a5de-5d7307621f05/Screenshot_20251211_105003_Samsung_Internet.jpg",
      ],
      adminMessage: "직장 내 승진과 명예로운 결실을 축원하며 불단에 향을 피웠습니다.",
    },
    {
      id: "real-bodeok-3",
      donorName: "하만수",
      birthDate: "1986.11.29",
      category: "학업/합격",
      wish: "하만수(1986.11.29) - 지혜의 광명으로 합격의 기쁨을 누릴 수 있게 해주세요.",
      candleColor: "white",
      itemName: "불공 기도",
      durationDays: 100,
      prayCount: 58,
      orderDate: "2025-06-16",
      templeName: "보덕사",
      isExpired: true,
      adminImages: [
        "https://binaida-asset.s3.ap-northeast-2.amazonaws.com/order-2bb56fa9-453e-47ec-87b5-2308da43ae96/1000010885.jpg",
      ],
      adminMessage: "문수보살님의 대지혜로 원하는 시험에 반드시 합격하도록 정진 기도를 올렸습니다.",
    },
    {
      id: "real-bodeok-4",
      donorName: "하만수 가족",
      birthDate: "",
      category: "가정화목",
      wish: "가정 내 모든 식구들이 우애 깊고 건강하며 화목하게 살아가기를 발원합니다.",
      candleColor: "pink",
      itemName: "불공 기도",
      durationDays: 100,
      prayCount: 71,
      orderDate: "2025-05-12",
      templeName: "보덕사",
      isExpired: true,
      adminImages: [
        "https://binaida-asset.s3.ap-northeast-2.amazonaws.com/order-b53d804f-3fb7-4a26-b56e-d74b9a246a04/220288a6-fac8-49bf-9ba7-f151075f2bd6.jpg",
      ],
      adminMessage: "보덕사 주지 스님 집전 하에 가족 축원 기도를 원만히 봉행하였습니다.",
    },
  ],

  // 5. 상운사
  "9a14599e-4d27-4e99-8c03-ba3262408f98": [
    {
      id: "real-sangun-1",
      donorName: "원성준",
      birthDate: "1978.10.09",
      category: "사업/재물",
      wish: "원성준(78년10월9일) - 사업번창과 무사안녕을 7일간 정성껏 발원합니다.",
      candleColor: "gold",
      itemName: "7일초",
      durationDays: 7, // 7일 불공
      prayCount: 21,
      orderDate: "2023-09-21",
      templeName: "상운사",
      isExpired: true,
      adminImages: [
        "https://binaida-asset.s3.ap-northeast-2.amazonaws.com/order-02bd21e0-a97e-4a08-93c6-6381925e4a05/9ddd9195-5327-40a0-9025-9b23e8f73d5b39151473044263492.jpg",
      ],
      adminMessage: "상운사 대웅전 불단에 7일간 꺼지지 않는 정성초를 올렸습니다.",
    },
  ],

  // 6. 동림사
  "85098a7b-be5f-42fd-879b-a50b311eb5cf": [
    {
      id: "real-dongrim-1",
      donorName: "하만수 가족",
      birthDate: "",
      category: "소원성취",
      wish: "동림사 부처님 전 소원성취 및 가족 평안을 간절히 발원합니다.",
      candleColor: "pink",
      itemName: "소원초 (30일 불공)",
      durationDays: 30,
      prayCount: 24,
      orderDate: "2023-08-18",
      templeName: "동림사",
      isExpired: true,
      adminImages: [
        "https://binaida-asset.s3.ap-northeast-2.amazonaws.com/order-8248aa78-0bca-4219-b7c1-638ac7a7715e/1783749173028.jpg",
      ],
      adminMessage: "동림사 관음전에서 하만수 가족의 만사여의와 소원성취를 축원드렸습니다.",
    },
  ],
};

// 촛불 접수일자 및 기간 상태(회향 완료 / 점등 중) 명확한 계산 헬퍼 함수
export const calculateCandlePeriodInfo = (candle) => {
  if (!candle) {
    return {
      orderDate: "",
      formattedDate: "",
      isExpired: false,
      daysText: "",
      shortTagText: "",
      statusBadgeText: "",
      subText: "",
      durationText: "",
      badgeVariant: "secondary",
    };
  }

  const orderDateStr = candle.orderDate || candle.created_at || "";

  // 불공 기도 기간 파악 (예: 7일초 -> 7일 불공, 100일초 -> 100일 기도 등)
  let duration = candle.durationDays;
  if (!duration) {
    if (candle.itemName?.includes("7일") || candle.daysPassed === 7) {
      duration = 7;
    } else if (candle.itemName?.includes("100") || candle.itemName?.includes("백일") || candle.daysPassed >= 70) {
      duration = 100;
    } else if (candle.itemName?.includes("3일")) {
      duration = 3;
    } else if (candle.itemName?.includes("49일")) {
      duration = 49;
    } else {
      duration = 30; // 기본 30일
    }
  }

  // 과거 접수된 실제 데이터는 모두 "회향 완료" 상태
  const isExpired = candle.isExpired !== undefined ? candle.isExpired : Boolean(candle.orderDate);

  if (isExpired) {
    return {
      orderDate: orderDateStr || "과거 접수",
      formattedDate: orderDateStr,
      isExpired: true,
      // "7일 지남" 대신 "7일 불공 회향 완료"로 직관적이고 정확하게 표현!
      daysText: `${duration}일 불공 회향 완료`,
      shortTagText: `회향 (${duration}일)`,
      statusBadgeText: `${duration}일 불공 회향`,
      subText: `대웅전 불단 ${duration}일간 정성 점등 완료 (회향)`,
      durationText: `${duration}일 불공`,
      badgeVariant: "danger",
    };
  }

  // 오늘 새로 접수하거나 기간이 남아있는 촛불
  const remaining = candle.daysLeft || duration;
  return {
    orderDate: orderDateStr || new Date().toISOString().split("T")[0],
    formattedDate: orderDateStr || "오늘 접수",
    isExpired: false,
    daysText: `${remaining}일 남음 (정성 점등 중)`,
    shortTagText: `${remaining}일 남음`,
    statusBadgeText: "정성 점등 중",
    subText: "대웅전 부처님 전 은은하게 점등 중",
    durationText: `${duration}일 불공`,
    badgeVariant: "success",
  };
};

// 사찰 이름으로도 매핑 가능하도록 헬퍼 함수 제공
export const getRealCandlesForTemple = (temple) => {
  if (!temple) return [];

  const templeId = String(temple.id || "");
  const templeName = String(temple.name || "").trim();

  // 1. ID로 직접 매칭
  if (REAL_TEMPLE_CANDLES_DB[templeId]) {
    return REAL_TEMPLE_CANDLES_DB[templeId];
  }

  // 2. 이름으로 매칭
  for (const [key, candles] of Object.entries(REAL_TEMPLE_CANDLES_DB)) {
    if (candles.length > 0 && candles[0].templeName === templeName) {
      return candles;
    }
  }

  // 3. 이름 부분 매칭 (예: "봉은사", "청계사", "선운정사")
  if (templeName.includes("봉은")) return REAL_TEMPLE_CANDLES_DB["baee5735-98a8-49cb-a541-1b6243372902"] || [];
  if (templeName.includes("청계")) return REAL_TEMPLE_CANDLES_DB["5f5f4e8f-be98-4162-8dc4-43b849e48fdd"] || [];
  if (templeName.includes("선운")) return REAL_TEMPLE_CANDLES_DB["6d23b2f3-419f-48af-ac2e-3854380bbf8a"] || [];
  if (templeName.includes("보덕")) return REAL_TEMPLE_CANDLES_DB["b9b4c4c1-f0fb-4aa1-8b19-6688e72d0fd5"] || [];
  if (templeName.includes("상운")) return REAL_TEMPLE_CANDLES_DB["9a14599e-4d27-4e99-8c03-ba3262408f98"] || [];
  if (templeName.includes("동림")) return REAL_TEMPLE_CANDLES_DB["85098a7b-be5f-42fd-879b-a50b311eb5cf"] || [];

  // 4. 그 외 사찰의 경우 기본 실제 데이터 (봉은사/청계사 데이터 기반)
  return REAL_TEMPLE_CANDLES_DB["baee5735-98a8-49cb-a541-1b6243372902"] || [];
};
